export default __webpack_public_path__ + "static/media/gallery - cover_00.d23e75df.jpg";